import { throttle, debounce } from 'throttle-debounce';
import timeouts from '~~/common/js/constants/timeouts';

export const DEFAULT_INTERVAL = timeouts.SENSITIVE;

/**
 * This mixin lets the Vue component easily add a controlled window
 * resize listener for more granular control.
 *
 * @param {string} resizeListener the name of the component method to call as resize callback
 * @param {string} mode control mode for the resize listener - 'debounced' (default) or 'throttled'
 * @param {string} interval control interval in milliseconds
 */
export default (resizeListener, mode = 'debounced', interval = DEFAULT_INTERVAL) => ({
  mounted() {
    if (resizeListener) {
      this.createResizeListener();
    }
  },
  beforeDestroy() {
    if (resizeListener) {
      window.removeEventListener('resize', this.screenResizeListener);
    }
  },
  methods: {
    createResizeListener() {
      this.screenResizeListener = () => {
        if (this[resizeListener]) {
          this[resizeListener]();
        }
      };
      // TODO: see if we could memoize the listener per mode+interval
      const controller = mode === 'throttled' ? throttle : debounce;
      window.addEventListener('resize', controller(interval, this.screenResizeListener));
      this.screenResizeListener();
    },
  },
});
